import { createAction } from '@reduxjs/toolkit';
import type { CreateNameSanitizationRuleRequest, NameSanitizationRule } from '@shared/schemas';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out of
 * the slice's reducers: they trigger side effects, not state transitions (the saga
 * owns the resulting `load*` / `save*` / `run*` ones).
 */

/** Load the blocklist (dispatched on mount). */
export const loadRequested = createAction('nameRules/loadRequested');

/** Add one entry to the blocklist. */
export const createRequested = createAction<CreateNameSanitizationRuleRequest>(
  'nameRules/createRequested',
);

/** Remove one entry. Not retroactive. */
export const deleteRequested = createAction<string>('nameRules/deleteRequested');

/** Empty one whole list. Touches no profile; it destroys the configuration. */
export const clearRequested = createAction<NameSanitizationRule['kind']>(
  'nameRules/clearRequested',
);

/** Run the current rules against one typed name, writing nothing. */
export const previewRequested = createAction<string>('nameRules/previewRequested');

/** Run the rules over the whole database. Not reversible. */
export const runRequested = createAction('nameRules/runRequested');
